// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".medi-block-text[data-v-346e299e]{background:#fff}.medi-block-text p[data-v-346e299e]{text-wrap:balance;font-size:1rem;line-height:1.2rem;margin:.25rem auto;max-width:1160px;padding:1rem;text-align:center;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
